<template>
  <div class="search_container">
    <div class="search_title">
      <div class="search_title_text">智能搜索</div>
      <div class="search_title_border">
        <div class="bread_crumbs_before_left"></div>
        <div class="bread_crumbs_before_right"></div>
      </div>
    </div>
    <div class="search_leaf_node">
      <input type="text" v-model="search_val" placeholder="请输入评测项目节点关键字" @keyup.enter="inputFn"/>
      <div class="search_leaf_button" @click="searchFn"></div>
    </div>
    <div class="search_filter flex">
      <div class="search_filter_text">搜索范围：</div>
      <div class="search_filter_optopns flex">
        <div class="search_filter_option flex" @click="changeTab(1)">
          <div class="search_filter_checked_box" :class="cur_tab==1?'act':''"></div>
          <div class="search_filter_checked_text">全部车型</div>
        </div>
        <template v-if="collect_list && collect_list.length">
          <div class="search_filter_option flex" @click="changeTab(2)">
            <div class="search_filter_checked_box" :class="cur_tab==2?'act':''"></div>
            <div class="search_filter_checked_text">收藏车型</div>
          </div>
        </template>
        <template v-else>
          <div class="search_filter_option flex disabled">
            <div class="search_filter_checked_box"></div>
            <div class="search_filter_checked_text">收藏车型</div>
          </div>
        </template>
        <el-popover
          placement="bottom"
          :width="200"
          trigger="hover"
          @after-leave="hidePopFn"
          popper-class="popover_box"
        >
          <template #reference>
            <div class="search_filter_option flex">
              <div class="search_filter_checked_box custom" :class="cur_tab==3?'act':''"></div>
              <div class="search_filter_checked_text">自定义车型</div>
            </div>
          </template>
          <div class="custom_cars">
            <div class="custom_car_tit">
              在所选车型内筛选(可多选)
            </div>
            <div class="custom_car_list">
              <div class="custom_car_item flex" 
                v-for="car in all_list" 
                :key="car.model_id"
                @click="triggerChecked(car,1)" 
                :class="car.checked?'act':''"
              >
                <div class="custom_car_checkbox"></div>
                <div class="custom_car_name">{{car.short_name}}</div>
              </div>
            </div>
            <div class="confirm_btn" @click="changeTab(3)">确定</div>

          </div>
        </el-popover>
      </div>
    </div>
    <div class="custom_cars flex" v-if="cur_tab == 3 && cur_car_list.length">
      <template v-for="item in cur_car_list" :key="item.model_id">
        <div class="custom_car flex">
          <div class="custom_car_name">{{item.short_name}}</div>
          <div class="custom_car_del" @click="triggerChecked(item,2)"></div>
        </div>
      </template>
    </div>

    <div class="result_tabs" v-if="node_list && node_list2">
      <div class="result_tab" :class="result_tab == 0?'act':''" @click="result_tab = 0">
        基础项({{node_list && node_list.length}})
      </div>
      <div class="result_tab" :class="result_tab == 1?'act':''" @click="result_tab = 1">
        创新项({{node_list2 && node_list2.length}})
      </div>
    </div>

    <div class="table_container" v-if="result_tab==0 && node_list">
      <el-table
        empty-text="没有匹配的相关项目节点"
        v-loading="loading"
        :data="node_list"
        row-key="id"
        border
      >
        <el-table-column
          :resizable="false"
          label="测评项"
          width=420
        >
          <template #default="scope">
            <div class="node_name">
              {{ scope.row.name }}
            </div>
            <div class="path_names">( <template v-for="(item, ind) in scope.row.path_node" :key="ind">
                <span v-if="ind > 0">></span><span>{{ item.node_name }}</span>
              </template> )
            </div>
            <div></div>
          </template>
        </el-table-column>
        <el-table-column
          :resizable="false"
          label="得分"
          min-width=300
        >
          <template #default="scope">
            <el-checkbox-group v-model="scope.row.checked_list" :max="3">
              <div class="model_list flex">
                <el-checkbox class="model_name" v-for="item in scope.row.model_list" :key="item.model_id" :label="item">
                  {{item.short_name}}({{item.score}}分)
                </el-checkbox>
              </div>
            </el-checkbox-group>
          </template>
        </el-table-column>
        <el-table-column
          :resizable="false"
          label="操作"
          width=80
        >
          <template #default="scope">
            <div class="contrast_btn" @click="contrastFn(scope.row);showRuleDesc=false;">对比</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="table_container" v-if="result_tab==1 && node_list2">
      <el-table
        empty-text="没有匹配的相关项目节点"
        v-loading="loading"
        :data="node_list2"
        row-key="id"
        border
      >
        <el-table-column
          :resizable="false"
          label="测评项"
          width=420
        >
          <template #default="scope">
            <div class="node_name">
              {{ scope.row.name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :resizable="false"
          label="得分"
          min-width=300
        >
          <template #default="scope">
            <el-checkbox-group v-model="scope.row.checked_list" :max="3">
              <div class="model_list flex">
                <el-checkbox class="model_name" v-for="item in scope.row.model_list" :key="item.model_id" :label="item">
                  {{item.short_name}}({{item.score}}分)
                </el-checkbox>
              </div>
            </el-checkbox-group>
          </template>
        </el-table-column>
        <el-table-column
          :resizable="false"
          label="操作"
          width=80
        >
          <template #default="scope">
            <div class="contrast_btn" @click="contrastFn2(scope.row);showRuleDesc=false;">对比</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 测评详情表格弹窗 -->
    <el-drawer
      v-model="dialogVisible"
      :title="node_name"
      direction="rtl"
      :before-close="handleClose"
      :size="'auto'"
      modal-class="modal_transparent"
    >
      <div class="my_dialog" v-if="dialogVisible">
        <table class="detail_table" border="1">
          <tr class="detail_title">
            <td class="detail_attr">车型</td>
            <template
              v-for="(item, ind) in model_list"
              :key="ind"
            >
              <td class="detail_title_item" colspan="1">
                {{item.short_name }}
              </td>
            </template>
          </tr>
          <tr class="detail_tr_item" v-show="showRuleDesc == true">
            <td class="detail_attr">
              标准
              <span id="triangle-up" @click="showRuleDesc = false"></span>
            </td>
            <template v-for="(item, ind) in detail_list" :key="ind">
              <td class="detail_val">
                <template v-if="item.has_permission == 1">未开通权限</template>
                <template v-else>
                  <div
                    class="detail_val_text"
                    v-html="(item['9'] && item['9']) || '暂无'"
                  ></div>
                </template>
              
              </td>
            </template>
          </tr>
          <tr class="detail_tr_item">
            <!-- 背景色占位 -->
          </tr>
          <tr class="detail_tr_item" v-show="showRuleDesc == false">
            <td class="detail_attr">
              标准
              <span id="triangle-down" @click="showRuleDesc = true"></span>
            </td>
            <template v-for="(item, ind) in detail_list" :key="ind">
              <td class="detail_val">
                <template v-if="item.has_permission == 1">未开通权限</template>
                <template v-else>
                <div
                  style="
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    padding: 5px;
                  "
                  class="detail_val_text"
                  v-html="(item['9'] && item['9']) || '暂无'"
                ></div>
                </template>
              </td>
            </template>
          </tr>
          <tr class="detail_tr_item">
            <td class="detail_attr">
              <div>得分</div>
            </td>
            <template v-for="(item, ind) in detail_list" :key="ind">
              <td class="detail_val">
                <template v-if="item.has_permission == 1">未开通权限</template>
                <template v-else>
                <div class="attr_box">
                  <!-- <div class="attr_node_name">
                    {{ node_name }}
                  </div> -->
                  <div class="attr_node_score">
                    <span class="attr_node_score_num" style="color:#f00">{{ (item["1"] && item["1"].item_value_val) || 0 }}分</span>
                  </div>
                </div>
                </template>
              </td>
            </template>
          </tr>
          <tr class="detail_tr_item">
            <td class="detail_attr">主观评价</td>
            <template v-for="(item, ind) in detail_list" :key="ind">
              <td class="detail_val">
                <template v-if="item.has_permission == 1">未开通权限</template>
                <template v-else>
                <div
                  class="detail_val_text"
                  v-html="(item['2'] && item['2'].item_value_val) || '暂无'"
                ></div>
                </template>
              </td>
            </template>
          </tr>
          <!-- <tr class="detail_tr_item">
            <td class="detail_attr">客观信息</td>
            <template v-for="(item, ind) in detail_list" :key="ind">
              <td class="detail_val">
                <div
                  class="detail_val_text"
                  v-html="(item['3'] && item['3'].item_value_val) || '暂无'"
                ></div>
              </td>
            </template>
          </tr> -->
          <tr class="detail_tr_item">
            <td class="detail_attr">图片素材</td>
            <template v-for="(item, ind) in detail_list" :key="ind">
              <td class="detail_val">
                <template v-if="item.has_permission == 1">未开通权限</template>
                <template v-else>
                  <template v-if="item['4'] && item['4'].ext_info.length > 0">
                    <div class="detail_val_pic">
                      <div
                        class="detail_pic_left"
                        @click.stop="
                          previewImg(item['4'] && item['4'].ext_info, 'img')
                        "
                      >
                        <div class="detail_pic_left_img">
                          <img
                            :src="item['4'].ext_info[0].attach_value || ''"
                            alt="图片加载失败"
                          />
                          <span class="more_pic">{{
                            item["4"] && item["4"].ext_info.length
                          }}</span>
                        </div>
                        <div class="look_pic">点击查看图片</div>
                      </div>
                      <div
                        v-if="item['4'] && item['4'].item_value_val"
                        class="detail_pic_right detail_val_text"
                        v-html="item['4'] && item['4'].item_value_val"
                      ></div>
                    </div>
                    <div class="download_btn" v-if="store.getDownloadAuth(route_type)" @click="downloadFn(item['4'] && item['4'].ext_info,model_list[ind].short_name,node_name)"></div>
                  </template>
                  <div class="no_img" v-else>当前测试子节点本次未涉及图片素材</div>
                </template>
              </td>
            </template>
          </tr>
          <tr class="detail_tr_item">
            <td class="detail_attr">视频素材</td>
            <template v-for="(item, ind) in detail_list" :key="ind">
              <td class="detail_val">
                <template v-if="item.has_permission == 1">未开通权限</template>
                <template v-else>
                <template v-if="item['5'] && item['5'].ext_info.length > 0">
                  <div class="detail_val_video">
                    <div
                      class="detail_video_left"
                      @click.stop="
                        previewImg(item['5'] && item['5'].ext_info, 'video')
                      "
                    >
                      <div class="detail_pic_left_video">
                        <video controlsList="nodownload" :src="item['5'].ext_info[0].attach_value"
                          :poster="item['5'].ext_info[0].attach_value+'?spm=qipa250&x-oss-process=video/snapshot,t_1000,f_jpg,w_0,h_0,m_fast'"
                          preload="none"
                        ></video>
                        <span class="more_pic">{{
                          item["5"] && item["5"].ext_info.length
                        }}</span>
                      </div>
                      <div class="look_pic">点击查看视频</div>
                    </div>
                    <div
                      class="detail_pic_right detail_val_text"
                      v-if="item['5'] && item['5'].item_value_val"
                      v-html="item['5'] && item['5'].item_value_val"
                    ></div>
                  </div>
                  <div class="download_btn" v-if="store.getDownloadAuth(route_type)" @click="downloadFn(item['5'] && item['5'].ext_info,model_list[ind].short_name,node_name)"></div>
                </template>
                <div class="no_img" v-else>当前测试子节点本次未涉及视频素材</div>
                </template>
              </td>
            </template>
          </tr>
        </table>
      </div>
    </el-drawer>
    <!-- 图片视频swiper -->
    <div class="my_swiper_dialog" v-if="swiperVisible">
      <div class="my_swiper_dialog_content">
        <div class="my_swiper_dialog_close" @click="closeSwiperDialog"></div>
        <swiper :list="preview_list" :type="preview_type"/>
      </div>
    </div>


    <!-- 创新  测评详情表格弹窗 -->
    <el-drawer
      v-model="dialogVisible2"
      :title="node_name2"
      direction="rtl"
      :before-close="handleClose"
      :size="'auto'"
      modal-class="modal_transparent"
    >
      <div class="my_dialog" v-if="dialogVisible2">
        <table class="detail_table" border="1">
          <tr class="detail_title">
            <td class="detail_attr">车型</td>
            <template
              v-for="(item, ind) in model_list2"
              :key="ind"
            >
              <td class="detail_title_item" colspan="1">
                {{item.short_name }}
              </td>
            </template>
          </tr>
     
          <tr class="detail_tr_item">
            <td class="detail_attr">
              <div>维度评分</div>
            </td>
            <template v-for="(item, ind) in detail_list2" :key="ind">
              <td class="detail_val">
                <div class="td_score table_text">
                  <p>惊喜：{{ item.surprise_score || 0 }}分</p>
                  <p>实用：{{ item.practical_score || 0 }}分</p>
                  <p>独创：{{ item.originality_score || 0 }}分</p>
                </div>
              </td>
            </template>
          </tr>
          <tr class="detail_tr_item">
            <td class="detail_attr">
              <div>综合得分</div>
            </td>
            <template v-for="(item, ind) in detail_list2" :key="ind">
              <td class="detail_val">
                <div class="attr_box">
                  <div class="attr_node_score">
                    <span class="attr_node_score_num" style="color:#f00">{{item.synthetical_score}}分</span>
                  </div>
                </div>
              </td>
            </template>
          </tr>
   
          <tr class="detail_tr_item">
            <td class="detail_attr">图片素材</td>
            <template v-for="(item, ind) in detail_list2" :key="ind">
              <td class="detail_val">
                <template v-if="item.item['3'] && item.item['3'].ext_info.length > 0">
                  <div class="detail_val_pic">
                    <div
                      class="detail_pic_left"
                      @click.stop="
                        previewImg(item.item['3'] && item.item['3'].ext_info, 'img')
                      "
                    >
                      <div class="detail_pic_left_img">
                        <img
                          :src="item.item['3'].ext_info[0].attach_value || ''"
                          alt="图片加载失败"
                        />
                        <span class="more_pic">{{
                          item.item['3'] && item.item['3'].ext_info.length
                        }}</span>
                      </div>
                      <div class="look_pic">点击查看图片</div>
                    </div>
                    <div
                      v-if="item.item['3'] && item.item['3'].item_value_val"
                      class="detail_pic_right detail_val_text"
                      v-html="item.item['3'] && item.item['3'].item_value_val"
                    ></div>
                  </div>
                  <div class="download_btn" v-if="store.getDownloadAuth(route_type)" @click="downloadFn(item.item['3'] && item.item['3'].ext_info,model_list2[ind].short_name,node_name2)"></div>
                </template>
                <div class="no_img" v-else>当前测试子节点本次未涉及图片素材</div>
               
              </td>
            </template>
          </tr>
          <tr class="detail_tr_item">
            <td class="detail_attr">视频素材</td>
            <template v-for="(item, ind) in detail_list2" :key="ind">
              <td class="detail_val">
                <template v-if="item.item['4'] && item.item['4'].ext_info.length > 0">
                  <div class="detail_val_video">
                    <div
                      class="detail_video_left"
                      @click.stop="
                        previewImg(item.item['4'] && item.item['4'].ext_info, 'video')
                      "
                    >
                      <div class="detail_pic_left_video">
                        <video controlsList="nodownload" :src="item.item['4'].ext_info[0].attach_value"
                          :poster="item.item['4'].ext_info[0].attach_value+'?spm=qipa250&x-oss-process=video/snapshot,t_1000,f_jpg,w_0,h_0,m_fast'"
                          preload="none"
                        ></video>
                        <span class="more_pic">{{
                          item.item['4'] && item.item['4'].ext_info.length
                        }}</span>
                      </div>
                      <div class="look_pic">点击查看视频</div>
                    </div>
                    <div
                      class="detail_pic_right detail_val_text"
                      v-if="item.item['4'] && item.item['4'].item_value_val"
                      v-html="item.item['4'] && item.item['4'].item_value_val"
                    ></div>
                  </div>
                  <div class="download_btn" v-if="store.getDownloadAuth(route_type)" @click="downloadFn(item.item['4'] && item.item['4'].ext_info,model_list2[ind].short_name,node_name2)"></div>
                </template>
                <div class="no_img" v-else>当前测试子节点本次未涉及视频素材</div>
                
              </td>
            </template>
          </tr>
          <tr class="detail_tr_item">
            <td class="detail_attr">主观评价</td>
            <template v-for="(item, ind) in detail_list2" :key="ind">
              <td class="detail_val">
                <div class="td_evaluation table_text">
                  <template
                    v-for="(p_item, p_ind) in item.item"
                    :key="p_ind"
                  >
                    <p
                      v-if="
                        p_item.item_value_val &&
                        p_item.item_value_type != 4 &&
                        p_item.item_value_type != 5
                      "
                      v-html="p_item.item_value_val"
                    ></p>
                  </template>
                </div>
              </td>
            </template>
          </tr>
          

        </table>
      </div>
    </el-drawer>
  </div>
  
</template>

<script>
import { ref } from "vue";
import { 
  getSearchModel, 
  getSearchResoult,
  getTestDetail,
  getSearchResoultCx,
  getInnovateDetail
} from "@/api_drive";
import { 
  getSearchModel as getSearchModel2, 
  getSearchResoult as getSearchResoult2,
  getTestDetail as getTestDetail2,
  getSearchResoultCx as getSearchResoultCx2,
  getInnovateDetail as getInnovateDetail2
} from "@/api";
import {
  ElPopover,
  ElMessage,
  ElCheckbox,
  ElCheckboxGroup,
  ElTable,
  ElTableColumn,
  ElDrawer
} from "element-plus";
import store from "@/store";
import Swiper from "@/components/swiper/Swiper.vue";
export default {
  components: {
    ElPopover,
    ElCheckbox,
    ElCheckboxGroup,
    ElTable,
    ElTableColumn,
    ElDrawer,
    Swiper
  },
  props:{
    route_type: {
      type: String,
      default: "",
    },
  },
  setup(props){
    const all_list = ref([]);
    const collect_list = ref([]);
    //  获取车型列表数据  is_collect值为1是收藏
    const getSearchModelFn = () => {
      let fetch_methods = props.route_type == 'drive'?getSearchModel:getSearchModel2;
      fetch_methods().then((res) => {
        let list1 = [],list2 = [];
        res.data.forEach(item => {
          list1.push(item);
          if(item.is_collect == 1){
            list2.push(item);
          }
        });
        all_list.value = JSON.parse(JSON.stringify(list1));
        prev_all_list.value = JSON.parse(JSON.stringify(list1));
        cur_car_list.value = JSON.parse(JSON.stringify(list1));
        collect_list.value = JSON.parse(JSON.stringify(list2));
      });
    };
    getSearchModelFn();
    const cur_tab = ref(1);
    const cur_car_list = ref([]);
    const prev_all_list = ref([]);
    const changeTab = (ind)=>{
      cur_tab.value = ind;
      if(ind == 1){
        cur_car_list.value = all_list.value;
        all_list.value = all_list.value.map(item=>{
          item.checked = false;
          return item;
        })
      }else if(ind == 2){
        cur_car_list.value = collect_list.value;
        all_list.value = all_list.value.map(item=>{
          item.checked = false;
          return item;
        })
      }else if(ind == 3){
        cur_car_list.value = all_list.value.filter(item=>{
          return item.checked;
        })
        prev_all_list.value = JSON.parse(JSON.stringify(all_list.value));
      }
    }
    const triggerChecked = (car,type)=>{
      console.log(car)
      all_list.value.forEach((item,ind)=>{
        if(item.model_id == car.model_id){
          all_list.value[ind].checked = !item.checked;
        }
      })
      if(type == 2){
        prev_all_list.value = JSON.parse(JSON.stringify(all_list.value));
        cur_car_list.value = all_list.value.filter(item=>{
          return item.checked;
        })
      }
    }
    const hidePopFn = ()=>{
      console.log(prev_all_list.value)
      all_list.value = JSON.parse(JSON.stringify(prev_all_list.value));
    }


    // 搜索结果
    const result_tab = ref(0);
    const node_list = ref(null);
    const search_val = ref("");
    const loading = ref(false);
    
    const node_list2 = ref(null);
    const loading2 = ref(false);
    const searchFn = () => {
      node_list.value = [];
      if (!search_val.value.trim()) {
        ElMessage.warning("请输入搜索内容！");
        return;
      }
      if(cur_car_list.value.length==0){
        ElMessage.warning("自定义模式中未选中任何车型！");
        return;
      }
      // node_list.value = [];
      loading.value = true;
      loading2.value = true;
      let model_id = cur_car_list.value
        .map((item) => {
          return item.model_id;
        })
        .join("-");
      let keyword = search_val.value;
      let fetch_methods = props.route_type == 'drive'?getSearchResoult:getSearchResoult2;
      fetch_methods({
        model_id,
        keyword,
      }).then((res) => {
        console.log('res1',res.data);
        node_list.value = res.data.map(item=>{
          return {
            ...item,
            checked_list:[]
          }
        }) || [];
        loading.value = false;
      });

      let fetch_methods2 = props.route_type == 'drive'?getSearchResoultCx:getSearchResoultCx2;
      fetch_methods2({
        model_id,
        keyword,
      }).then((res) => {
        console.log('res2',res.data);
        node_list2.value = res.data.map(item=>{
          return {
            ...item,
            checked_list:[]
          }
        }) || [];
        loading2.value = false;
      });
    };
    // 详情弹窗数据展示列表
    const detail_list = ref([]);
    // 详情弹窗控制
    const dialogVisible = ref(false);
    const model_list = ref([]);
    const node_name = ref("");
    const contrastFn = (row)=>{
      let { checked_list , name ,node_id} = row;
      node_name.value = name;
      model_list.value = JSON.parse(JSON.stringify(checked_list))
      if(!model_list.value.length){
        ElMessage.warning("请选择对比车型！");
        return ;
      }
      
      let promise_list2 = model_list.value.map((item) => {
        return new Promise((resolve, reject) => {
          let fetch_methods = props.route_type == 'drive'?getTestDetail:getTestDetail2;
          fetch_methods({
            report_id: item.report_id,
            model_id: item.model_id,
            node_id: node_id,
          })
            .then((res) => {
              resolve(res);
            })
            .catch((err) => {
              reject(err);
            });
        });
      });
      Promise.all(promise_list2).then((res_list) => {
        detail_list.value = res_list.map((res) => {
          let item_value = {
            has_permission:res.code == 503?1:0
          };
          if (res.data && res.data.item_value) {
            res.data.item_value.forEach((item) => {
              item_value[item.item_value_val_type] = item;
            });
            item_value["9"] = res.data["node_desc"];
          }
          return item_value;
        });
        dialogVisible.value = true;
      });

    }
    const showRuleDesc = ref(false);
    const swiperVisible = ref(false);
    const preview_list = ref([]);
    const preview_type = ref("img");
    const previewImg = (list, type) => {
      preview_list.value = list;
      preview_type.value = type;
      swiperVisible.value = true;
    };
    const closeSwiperDialog = () => {
      document.querySelectorAll("video").forEach((item) => {
        item.pause();
      });
      swiperVisible.value = false;
    };

    const dialogVisible2 = ref(false);
    const detail_list2 = ref([]);
    const model_list2 = ref([]);
    const node_name2 = ref("");
    const contrastFn2 = (row)=>{
      let { checked_list , name } = row;
      console.log(row)
      node_name2.value = name;
      model_list2.value = JSON.parse(JSON.stringify(checked_list))
      if(!model_list2.value.length){
        ElMessage.warning("请选择对比车型！");
        return ;
      }
      let fetch_methods3 = props.route_type == 'drive'?getInnovateDetail:getInnovateDetail2;
      
      let promise_list = checked_list.map(item=>{
        return new Promise((resolve,reject)=>{
          fetch_methods3({
            report_id:item.report_id,
            model_id:item.model_id,
            node_ids:item.node_id
          }).then((res) => {
            resolve(res);
          }).catch((err) => {
            reject(err);
          });
        })
      })
      Promise.all(promise_list).then(res_list=>{
        detail_list2.value = res_list.map(res_item=>{
          let res_item_data = res_item.data[0];
          let item_item_val = {};
          res_item_data.item.forEach(item_item=>{
            item_item_val[item_item.item_value_type] = item_item;
          })
          res_item_data.item = item_item_val;
          return res_item_data;
        })
        dialogVisible2.value = true;
        console.log(detail_list2.value);
      })
      
    }

    const inputFn = ()=>{
      searchFn();
    }
    const downloadFn = (list,model_name,node_name)=>{
      store.addDownload(list,model_name,node_name);
      ElMessage.success("已添加到下载队列中")
    }
    return {
      all_list,
      collect_list,
      cur_car_list,
      cur_tab,
      changeTab,
      triggerChecked,
      hidePopFn,

      result_tab,

      loading,
      node_list,
      loading2,
      node_list2,
      search_val,
      searchFn,
      contrastFn,
      inputFn,

      contrastFn2,


      model_list,
      dialogVisible,
      detail_list,
      node_name,

      model_list2,
      dialogVisible2,
      detail_list2,
      node_name2,


      showRuleDesc,

      preview_list,
      preview_type,
      previewImg,
      swiperVisible,
      closeSwiperDialog,

      downloadFn,
      store
    }
  }
}
</script>
<style lang="less">
.el-popper.popover_box{
  background: #252245;
  .el-popper__arrow::before{
    background: #252245;
  }
}

</style>
<style lang="less" scoped>

.search_container{
  width: 1200px;
  background: #fff;
  padding:20px 40px;
  .search_title{
    position: relative;
    height: 46px;
    line-height: 46px;
    .search_title_text{
      font-size: 14px;
      font-weight: bold;
      color: #0E0A31;
      text-align: center;
    }
    .search_title_border{
      display: flex;
      align-items: center;
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      .bread_crumbs_before_left{
        width: 28px;
        height: 2px;
        background: #1FBCBF;
      }
      .bread_crumbs_before_right{
        width: 27px;
        height: 2px;
        background: #DCDCDC;
      }
    }
  }
  .search_leaf_node {
    margin: 30px auto 10px;
    width: 692px;
    height: 52px;
    border-radius: 2px;
    border: 1px solid #DEDEDE;
    background-position: 179px center;
    display: flex;
    align-items: center;
    font-size: 16px;
    input {
      width: 100%;
      height: 100%;
      appearance: none;
      outline: none;
      border: none;
      background: transparent;
      padding: 0 10px 0 30px;
      font-size: 14px;
      &::placeholder{
        color: #bebebe;
      }
    }
    &:has(input:focus){
      border: 1px solid #1FBCBF;
    }
    .search_leaf_button {
      width: 50px;
      height: 100%;
      background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/ssh_20221229.png)
        no-repeat center center;
      background-size: 17px 17px;
      cursor: pointer;
    }
  }
  .search_filter{
    padding: 12px 0;
    justify-content: center;
    align-items: center;
    .search_filter_text{
      font-size: 14px;
      color: #0E0A31;
    }
    .search_filter_optopns{
      align-items: center;
      .search_filter_option{
        align-items: center;
        margin-right: 14px;
        cursor: pointer;
        .search_filter_checked_box{
          width: 15px;
          height: 15px;
          background: #FFFFFF;
          border-radius: 2px;
          border: 1px solid #BFBFBF;
          position: relative;
          margin: 0 6px;
          &.act:not(.custom){
            &::after{
              content: "";
              width: 8px;
              height: 8px;
              background: #1FBCBF;
              border-radius: 1px;
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%,-50%);
            }
          }
          &.custom{
            &::after{
              content: "";
              width: 0px;
              height: 0px;              
              border-radius: 2px;
              border: solid 4px transparent;
              border-bottom: solid 6px #929292;
              position: absolute;
              left: 50%;
              top:50%;
              transform: translate(-50%,-75%);
            }
            &.act{
              &::after{
                content: "";
                width: 0px;
                height: 0px;              
                border-radius: 2px;
                border: solid 4px transparent;
                border-bottom: solid 6px #1FBCBF;
                position: absolute;
                left: 50%;
                top:50%;
                transform: translate(-50%,-75%);
              }
            }
          }
        }
        .search_filter_checked_text{
          font-size: 12px;
          color: #0E0A31;
        }
        &.disabled{
          .search_filter_checked_box{
            background: #eee;
            border: solid 1px #ddd;
          }
          .search_filter_checked_text{
            color: #aaa;
          }
        }

      }
    }
  }
  .custom_cars{
    width: 692px;
    margin: 0 auto;
    padding: 6px 0 6px 40px;
    background: #F5F6F7;
    border-radius: 2px;
    flex-wrap: wrap;
    .custom_car{
      margin-right: 20px;
      align-items: center;
      .custom_car_name{
        font-size: 12px;
        color: #5F6E7E;
      }
      .custom_car_del{
        margin-left: 2px;
        width: 22px;
        height: 22px;
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/del_20230128.png) no-repeat center center;
        background-size: 12px;
        cursor: pointer;
      }
    }
  }
}
.custom_cars{
  max-height: 270px;
  padding: 4px;
  .custom_car_tit{
    height: 16px;
    font-size: 12px;
    color: #B7B7B7;
    line-height: 16px;
  }
  .custom_car_list{
    max-height:180px;
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    margin-top: 10px;
    .custom_car_item{
      cursor: pointer;
      height: 25px;
      align-items: center;
      .custom_car_checkbox{
        width: 15px;
        height: 15px;
        border-radius: 2px;
        border: 1px solid #939393;
      }
      .custom_car_name{
        margin-left: 10px;
        font-size: 12px;
        color: #B7B7B7;
      }
    &.act{
      .custom_car_checkbox{
        position: relative;
        &::after{
          content: "";
          width: 8px;
          height: 8px;
          background: #1FBCBF;
          border-radius: 1px;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%,-50%);
        }
      }
    }

    }
  }
  .confirm_btn{
    cursor: pointer;
    width: 78px;
    height: 26px;
    font-size: 12px;
    text-align: center;
    color: #FFFFFF;
    line-height: 26px;
    background: #2CC0C3;
    border-radius: 3px;
    margin: 15px auto 0;
  }
}
.result_tabs{
  display: flex;
  align-items: center;
  margin-top: 20px;
  .result_tab{
    height: 36px;
    line-height: 36px;
    padding: 0 10px;
    margin-right: 30px;
    font-size: 16px;
    border-bottom: solid 2px transparent;
    cursor: pointer;
    &.act{
      font-weight: bold;
      border-bottom: solid 2px #1FBCBF;
    }
  }
}

.table_container{
  width: 1130px;
  margin: 20px auto;
}

.node_name{
  padding: 0 10px;
  font-size: 16px;
  color: #555;
  font-weight: 900;
}
.path_names{
  padding: 0 10px;
  font-size: 12px;
  white-space: pre-wrap;
}
.model_list{
  flex-wrap: wrap;
  .model_name{
    flex-grow: 0;
    width: 200px;
    margin: 0;
  }
}
.contrast_btn{
  color: #709ae8;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: pointer;
}
:deep(.modal_transparent) {
  background: transparent;
}
.my_dialog {
  width: auto;
  height: auto;
  background: #fff;
  border-radius: 15px;
  padding: 10px;
  max-width: 90vw;
  height: calc(100vh - 75px);
  overflow-x: auto;
  overflow-y: auto;
  z-index: 99;
}

.detail_table .detail_tr_item .detail_val > div.detail_val_text {
  padding: 16px 17px;
  white-space: pre-line;
}
.no_img {
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: #777c89;
}
.detail_val_pic {
  display: flex;
  align-items: center;
  .detail_pic_left {
    width: 73px;
    height: 80px;
    cursor: pointer;
    .detail_pic_left_img {
      width: 73px;
      height: 60px;
      position: relative;
      img {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
      .more_pic {
        width: 20px;
        height: 25px;
        background: rgba(0, 0, 0, 0.5);
        position: absolute;
        bottom: 0;
        right: 0;
        text-align: center;
        list-style: 25px;
        font-size: 13px;
        font-weight: bold;
        color: #ffffff;
      }
    }
  }
  .detail_pic_right {
    font-size: 12px;
    font-weight: bold;
    color: #777c89;
    line-height: 16px;
  }
}
.detail_val_video {
  display: flex;
  align-items: center;
  .detail_video_left {
    width: 92px;
    height: 84px;
    cursor: pointer;
    .detail_pic_left_video {
      width: 92px;
      height: 64px;
      position: relative;
      video {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
      .more_pic {
        width: 20px;
        height: 25px;
        background: rgba(0, 0, 0, 0.5);
        position: absolute;
        bottom: 0;
        right: 0;
        text-align: center;
        list-style: 25px;
        font-size: 13px;
        font-weight: bold;
        color: #ffffff;
      }
    }
    .look_pic {
      width: 100%;
      height: 16px;
      font-size: 12px;
      color: #5287ea;
      line-height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.look_pic {
  width: 100%;
  height: 16px;
  font-size: 12px;
  color: #5287ea;
  line-height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.my_swiper_dialog {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 5000;
  .my_swiper_dialog_content {
    width: auto;
    height: auto;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .my_swiper_dialog_close {
      width: 50px;
      height: 50px;
      background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/a467vc54678bvt67bv.png) no-repeat center center;
      background-size: 50px 50px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 40px;
      position: absolute;
      top: 40px;
      right: 40px;
      z-index: 2;
      cursor: pointer;
    }
  }
}

#triangle-up {
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 10px solid;
}
#triangle-down {
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 10px solid;
}

.td_score{
  padding-left: 17px;
}
.td_evaluation {
  max-width: 480px;
  text-align: left;
  white-space: pre-line;
  p {
    padding: 10px;
    font-size: 12px;
    color: #777c89;
    line-height: 16px;
  }
}


</style>
